import * as React from 'react';
import { Button, Spinner } from 'reactstrap';

export function AdHocReportTile(props: {
    actionType: string;
    tileTitle: string;
    tileDescription: string;
    icon: string;
    isEnabled: boolean;
    isLoading: boolean;
    clickAction: (atype: string) => void
}) {
    return (
        <div className="my-3">
            <div hidden={props.isLoading == false}>
                <Spinner children={''} style={{ width: '1rem', height: '1rem', marginRight: '1em' }}
                    type="grow" color="warning"
                    hidden={props.isLoading == false} />
                {props.tileDescription}
            </div>
            <div hidden={props.isLoading == true}>
                <Button className="mr-3 btn btn-success" disabled={!props.isEnabled}
                    onClick={() => props.clickAction(props.actionType)}
                ><i className={props.icon}></i>
                </Button>
                {props.tileDescription}
            </div>

        </div>
    );
}